import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CameraWaste } from '@classes/waste-camera/waste-camera';
import { CameraWasteService } from '@services/cameraWaste/CameraWasteService';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.scss']
})
export class CameraComponent implements OnInit {

  lat = 50.597551;
  lng = 3.403683;
  cameraWaste: CameraWaste[];
  alerte: string;
  choiceDateForm: UntypedFormGroup;
  today = new Date();
  tab = 'camera';



  displayedColumns: string[] = ['camera', 'batterie', 'infraction'];
  dataSource: MatTableDataSource<CameraWaste>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions = [5, 10, 25, 100];


  markersWaste = [
    {
      lat: 50.517546,
      lng: 3.403655,
      label: 'Caméra 1',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.532996,
      lng: 3.403978,
      label: 'Caméra 2',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.584796,
      lng: 3.378345,
      label: 'Caméra 3',
      iconUrl: "assets/img/camera.svg"
    },
    {
      lat: 50.523115,
      lng: 3.384552,
      label: 'Caméra 4',
      iconUrl: "assets/img/camera.svg"
    }

  ];




  constructor(

    private CameraWasteService: CameraWasteService,
    private formBuilder: UntypedFormBuilder
  ) {

  }
  ngOnInit(): void {
    this.getCameraWaste();

    this.initForm();

  }
  onSubmit(changeCamera: boolean): void {

  }



  changeValueInputFrom(): void {
    const dateFrom = new Date(this.choiceDateForm.get('from').value).getTime();
    const dateTo = new Date(this.choiceDateForm.get('to').value).getTime();

    const date = new Date(this.choiceDateForm.get('to').value);
    date.setDate(date.getDate() - 7);

    if (dateTo <= dateFrom) {
      this.choiceDateForm.get('from').setValue(date);

    }
  }

  setTab(tab: string): void {
    this.tab = tab;
  }


  private getCameraWaste(): void {

    this.cameraWaste = this.CameraWasteService.waste;
    this.dataSource = new MatTableDataSource<CameraWaste>(this.cameraWaste);

  }
  private initForm(): void {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    this.choiceDateForm = this.formBuilder.group({

      from: [date, Validators.required],
      to: [this.today, Validators.required]
    });




  }
}
